import { Injectable } from '@angular/core';

// Services
import { UserService } from './user.service';

// RxJS
import { map, Observable } from 'rxjs';

// Models
import { User, UsersListElem } from '../models/user.model';


@Injectable({
  providedIn: 'root'
})
export class DemoUserService extends UserService {
  override listAdminUsers(): Observable<UsersListElem[]> {
    return super.listAdminUsers().pipe(
      map(users =>
        users.map(user => ({
          ...user,
          surname: '*****',
          email: '****@***',
          telephone: '*****'
        }))
      )
    );
  }

  override userDetail(userId: string): Observable<User> {
    return super.userDetail(userId).pipe(
      map(user => ({
        ...user,
        surname: '*****',
        email: '****@***',
        telephone: '*****'
      }))
    );
  }

  override getGroupAssociableUsers(groupId: string): Observable<User[]> {
    return super.getGroupAssociableUsers(groupId).pipe(
      map(users =>
        users.map(user => ({
          ...user,
          surname: '*****',
          email: '****@***',
          telephone: '*****'
        }))
      )
    );
  }
}